import type { useValidator } from '@ps-smart-cp/ppfw-client';
import type { CustomFieldSetting } from '../hooks';
import { SingleCustomField } from '../models';
import { createCustomValidateItem } from './createCustomFieldItem';
import { createCustomFieldId } from './customFieldBuilder';

const validateCustomFields = (
  customFields: SingleCustomField[],
  validator: ReturnType<typeof useValidator>,
  customFieldSettings: CustomFieldSetting[],
  index?: number,
) => {
  const customFieldMap = new Map<number, SingleCustomField>();
  customFields.forEach((customField) => customFieldMap.set(customField.customFieldKey, customField));

  return customFieldSettings.flatMap((setting) => {
    return validator
      .with(
        customFieldMap.get(setting.customFieldKey) ?? SingleCustomField.init(setting.customFieldKey),
        createCustomValidateItem(setting),
      )
      .execute()
      .map((err) => ({
        ...err,
        field: createCustomFieldId(setting, index),
      }));
  });
};

export { validateCustomFields };
